import AlertSidePanel from "../ac2Alerts/alertSidePanel";
import { AlertsSideModal } from "../ac2Alerts/alertsSideModal";
import { StyledAnalystDash } from "./analystDash.styled";
import { AnalystTable } from "./analystTable";


/**
 * This component tries to separate out the related components
 * that do not have to do with the Redux list of alerts and 
 * those that do, this is so that only the affected components
 * are refreshed when data is added or changed.
 * @returns 
 */
export const AnalystDash = () => {
  return (
    <div className="p-3 h-full">
      <StyledAnalystDash className="flex h-full overflow-hidden" style={{ width: '100%', height: '100%' }}>
        {/* The more information modal */}
        <AlertsSideModal />
        
        {/* All data tied to the Redux list of alerts */}
        <AnalystTable />
        <AlertSidePanel />
      </StyledAnalystDash>
    </div>
  );
};
